import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Popover, UndoIcon } from '@treams/treams-ui';

// Confirms reverting a submitted talent review back to draft and explains what that does.
export default function RevertTalentReviewModal(props: {
	/** Title of the cycle moment the review was submitted for. */
	title: string;
	/** Formatted deadline, when the moment has one. */
	deadline?: string;
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover visible center onDismiss={props.onClose}>
			<Modal>
				<Modal.Header title={t('talentReviews.v2.cycle.revertTitle')} onClose={props.onClose} />
				<Modal.Contents>
					<Paragraph>
						{props.deadline
							? t('talentReviews.v2.cycle.revertConfirm', {
									title: props.title,
									deadline: props.deadline,
								})
							: t('talentReviews.v2.cycle.revertConfirmNoDeadline', { title: props.title })}
					</Paragraph>
				</Modal.Contents>
				<Modal.Footer>
					<Button
						type="secondary"
						role="button"
						aria-label={t('talentReviews.v2.cancel')}
						title={t('talentReviews.v2.cancel')}
						disabled={props.loading}
						onClick={props.onClose}
					/>
					<Button
						ml={2}
						type="primary"
						role="button"
						aria-label={t('talentReviews.v2.cycle.revert')}
						icon={<UndoIcon />}
						title={t('talentReviews.v2.cycle.revert')}
						loading={props.loading}
						onClick={props.onConfirm}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
